import { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Stack, Button, Typography, TextField, Alert} from '@mui/material';
import { useNavigate } from "react-router-dom";
import { Paid } from '@mui/icons-material';
import "../App.scss";


const UserSettings = () => {
    const navigate = useNavigate();
    const outerBoxStyle = {
        bgcolor:'#EFEFEF', 
        p:4,
        borderRadius:5,
        alignSelf:'center',
        textAlign:'center',
    };
    const textFieldStyle = {
        borderRadius:0,
    };
    const [error, setError] = useState("");
    const [goodNotif, setGoodNotif] = useState("");
    const [userInfo, setUserInfo] = useState({
        firstName:'',
        lastName:'',
        userId: '',
        examTokens:'',
        email:'',
        phoneNumber:'',
    })
    const [userType, setUserType] = useState('');
    const [canSave, setCanSave] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token) {
            axios
                .get(`${process.env.REACT_APP_API_BASE_URL}/api/user-info`,{
                headers: {
                    Authorization:`Bearer ${token}`
                }
                })
                .then((response) => {
                if (response.status === 200) {
                    setUserType(response.data.userType);
                    setUserInfo({
                        firstName: response.data.firstName,
                        lastName: response.data.lastName,
                        userId: response.data.userId,
                        examTokens: response.data.examTokens,
                        email: response.data.email,
                        phoneNumber: response.data.phoneNumber,
                    });
                    setCanSave(true);
                }
                })
                .catch((error) => {
                    setError("Failed to retrieve user information.");
                });
        } else {
            setError('Your session in not authenticated, please log out and sign back in.')
        }
    },[]);


    const [userData, setUserData] = useState({
        email: userInfo.email,
        phone_number: userInfo.phoneNumber,
    });

    useEffect(() => {
        setUserData({
            email: userInfo.email,
            phone_number: userInfo.phoneNumber,
        });
    }, [userInfo]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
      };

    const saveUserInfo = (userData) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            try{
                axios
                .post(`${process.env.REACT_APP_API_BASE_URL}/api/update-user-info/`, {
                    user_data:userData
                },{
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then((response)=>{
                    if (response.status === 200) {
                        setGoodNotif('Successfully Updated User Information!');
                    } else {
                        setError("Unable to save user data.");
                    }
                })
                .catch((error)=>{
                    setError("Unable to save user data");
                })
            } catch (err) {
                setError("Unable to save user data");
            }
        } else {
            setError("Your session is not authenticated, please log out and sign in again.");
        }
    };


    return (
        <Box sx={{width:'100%', display:'flex', flexDirection:'column', justifyItems:'center'}}>
        <Box sx={{...outerBoxStyle, maxWidth:'950px', width: '100%'}}>
            <Typography variant="h4">User Settings</Typography>
            <Stack direction={'column'} sx={{ mt:2, justifySelf:'center', width:'100%', textAlign:'left'}}>
                <Typography variant="h5">{userInfo.lastName}, {userInfo.firstName}</Typography> 
                <Typography>ID: {userInfo.userId}</Typography>
                <div className='token-count'><Paid />{userInfo.examTokens}</div>
            </Stack>
            <Stack direction={'row'} spacing={2} sx={{justifyContent:'center', mt:4}}>
                <Stack spacing={2} sx={{width:'100%'}}>
                    <TextField
                        sx={textFieldStyle}
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={userData.email}
                        onChange={handleChange}
                    ></TextField>
                    <TextField
                        sx={textFieldStyle}
                        fullWidth
                        label="Phone Number"
                        name="phone_number"
                        type="tel"
                        value={userData.phone_number}
                        onChange={handleChange}
                    ></TextField>
                </Stack>
            </Stack>
            <Box sx={{width:'100%', justifySelf:'center'}}>
                <Stack direction={'row'} spacing={1} sx={{mt:2, justifyContent:'space-between', width:'100%'}}>
                    <Button variant='outlined' onClick={()=>(userType === 'district_admin' ? navigate('/statistics') : navigate('/'))} sx={{}}>Cancel</Button>
                    <Button variant='contained' onClick={()=>{saveUserInfo(userData)}} sx={{}} disabled={canSave === false}>Save Changes</Button>
                </Stack>
            </Box>
        </Box>
        <Box sx={{ width:'100%', mt:2, alignSelf:'center'}}>
            {error && <Alert severity='error' sx={{mb:1}} onClose={() => {setError('')}}>{error}</Alert>}
            {goodNotif && <Alert severity='success' sx={{mb:1}} onClose={()=>{setGoodNotif('')}}>{goodNotif}</Alert>} 
        </Box>
        </Box>
        
    );
};

export default UserSettings